import { createCommand } from 'lexical'

import { TableColBarClickPayload, TableRowBarClickPayload } from './interface'

export const TABLE_COL_BAR_CLICK_COMMAND =
  createCommand<TableColBarClickPayload>('TABLE_COL_BAR_CLICK_COMMAND')

export const TABLE_ROW_BAR_CLICK_COMMAND =
  createCommand<TableRowBarClickPayload>('TABLE_ROW_BAR_CLICK_COMMAND')

export const TABLE_CORNER_BAR_CLICK_COMMAND = createCommand<void>(
  'TABLE_CORNER_BAR_CLICK_COMMAND'
)
